import React from 'react';
import { Link } from 'react-router-dom';
import './ServicesPreview.css';

const ServicesPreview: React.FC = () => {
  const services = [
    {
      id: 1,
      title: "Architectural Design",
      description: ""
    },
    {
      id: 2,
      title: "Interior Design",
      description: ""
    },
    {
      id: 3,
      title: "Design & Build",
      description: ""
    },
    {
      id: 4,
      title: "Custom Furniture",
      description: ""
    },
    {
      id: 5,
      title: "Post-Project Services",
      description: ""
    }
  ];

  return (
    <section className="services-preview-wrapper">
      <div className="container">
        <div className="services-preview-header">
          <div className="services-left">
            <h1>We offer</h1>
            <h1><span id="gold">professional design</span> and architecture services for any project.</h1>
          </div>
          <div className="services-right">
            <div className="services-grid">
              {services.map((service) => (
                <div key={service.id} className="service-preview-card">
                  <div className="service-number" id="gold">0{service.id}.</div>
                  <h3>{service.title}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="services-preview-cta">
          <div className="cta-buttons">
            <Link to="/services" className="explore-services-btn secondary">
              <div className="btn-text">
                <h4>Explore All Services</h4>
              </div>
              <div className="btn-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12h14m-7-7 7 7-7 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </Link>
            
            <Link to="/contact" className="get-quote-btn primary">
              <div className="btn-text">
                <h4>Get Your Free Quote</h4>
              </div>
              <div className="btn-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </Link>
          </div>
          
          {/* <div className="funnel-stats">
            <div className="stat-item">
              <h3>50+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat-item">
              <h3>15+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat-item">
              <h3>98%</h3>
              <p>Client Satisfaction</p>
            </div>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default ServicesPreview;